export const ADYEN_SUPPORTED_COUNTRY_CODES = [
	'AT', // Austria
	// 'AU', // Australia, not yet supported by us
	'BE', // Belgium
	// 'CA', // Canada, not yet supported by us
	'HR', // Croatia
	'CZ', // Czech Republic
	'DK', // Denmark - PILOT
	'EE', // Estonia
	'FI', // Finland
	'FR', // France
	'DE', // Germany
	'GR', // Greece
	'IE', // Ireland
	'IT', // Italy
	'LV', // Latvia
	'LT', // Lithuania
	'LU', // Luxembourg
	'NL', // the Netherlands
	'NO', // Norway - PILOT
	'PL', // Poland
	'PT', // Portugal
	'SK', // Slovakia
	'SI', // Slovenia
	'ES', // Spain
	'SE', // Sweden
	'CH', // Switzerland
	'GB', // the United Kingdom (including Isle of Man & Jersey)
	// 'US', // the United States, not yet supported by us
] as const;

export const ADYEN_HOP_COUNTRY_CODES = ADYEN_SUPPORTED_COUNTRY_CODES;

export const STRIPE_SUPPORTED_COUNTRY_CODES = [
	'AT', // Austria
	'AU', // Australia
	'BE', // Belgium
	'BR', // Brazil
	'BG', // Bulgaria
	'CA', // Canada
	'HR', // Croatia
	'CY', // Cyprus
	'CZ', // Czech Republic
	'DK', // Denmark
	'EE', // Estonia
	'FI', // Finland
	'FR', // France
	'DE', // Germany
	'GI', // Gibraltar
	'GR', // Greece
	'HK', // Hong Kong
	'HU', // Hungary
	'IN', // India (Preview)
	'IE', // Ireland
	'IT', // Italy
	'JP', // Japan
	'LV', // Latvia
	'LI', // Liechtenstein
	'LT', // Lithuania
	'LU', // Luxembourg
	'MY', // Malaysia
	'MT', // Malta
	'MX', // Mexico
	'NL', // the Netherlands
	'NZ', // New Zealand
	'NO', // Norway
	'PL', // Poland
	'PT', // Portugal
	'RO', // Romania
	'SG', // Singapore
	'SK', // Slovakia
	'SI', // Slovenia
	'ES', // Spain
	'SE', // Sweden
	'CH', // Switzerland
	'AE', // United Arab Emirates
	'GB', // the United Kingdom
	'US', // the United States
] as const;

export const STRIPE_HOP_COUNTRY_CODES = STRIPE_SUPPORTED_COUNTRY_CODES;
